export class Functionality {
  benefitProvided: string;
  currentState: string;
  futureState: string;
  capitalCost: number;
  omCost: number;
}
